"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 6C8.69 6 6 8.691 6 12c0 3.308 2.691 6 6 6 3.308 0 6-2.692 6-6 0-3.309-2.692-6-6-6zm4.799 6c0 1.11-.379 2.132-1.013 2.945L9.059 8.21A4.775 4.775 0 0112 7.201 4.804 4.804 0 0116.8 12zM7.2 12c0-1.107.377-2.127 1.01-2.94l6.724 6.734A4.774 4.774 0 0112 16.799a4.804 4.804 0 01-4.799-4.8z" }), "Prohibited");
//# sourceMappingURL=Prohibited.js.map